import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SubjectService {

  public addonBuySuccessfully: BehaviorSubject<any> = new BehaviorSubject(null);
  public addonBuyError: BehaviorSubject<any> = new BehaviorSubject(null);
  public subscribeLogin: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public currentAccount: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public generalNotification: BehaviorSubject<any> = new BehaviorSubject(null);
  public account: BehaviorSubject<any> = new BehaviorSubject(null);
  public sku: BehaviorSubject<any> = new BehaviorSubject(null);
  public skuDetails: BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedFilter: BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedSort: BehaviorSubject<any> = new BehaviorSubject(null);
  public filteredData:BehaviorSubject<any> = new BehaviorSubject(null);
  public filteredItemsData:BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedAccount:BehaviorSubject<any> = new BehaviorSubject(null);
  public resetFilter:BehaviorSubject<any> = new BehaviorSubject(null);
  public resetVerification:BehaviorSubject<any> = new BehaviorSubject(null);
  public skuBackendIdDetail:BehaviorSubject<any> = new BehaviorSubject(null);
  public recommendedAddonsSkus:BehaviorSubject<any> = new BehaviorSubject(null);
  public areanProAddonBuySuccessfully: BehaviorSubject<any> = new BehaviorSubject(null);
  public filterPopupOpenCountryList: BehaviorSubject<any> = new BehaviorSubject(null);
  public onCountrySelectionChange: BehaviorSubject<any> = new BehaviorSubject(null);
  public selectedSortPrice: BehaviorSubject<any> = new BehaviorSubject(null);
  public removeSFList: BehaviorSubject<any> = new BehaviorSubject(null);
  public invokeCDRforRoamingCountrySelection: BehaviorSubject<any> = new BehaviorSubject(null);
  public currentAccountNavigationBar: BehaviorSubject<any> = new BehaviorSubject(null);
  public enableSubscribeButtonAgain: BehaviorSubject<any> = new BehaviorSubject(null);
  public acceptTermsAndConditions: BehaviorSubject<any> = new BehaviorSubject(null);
  public routingService: BehaviorSubject<any> = new BehaviorSubject(null);
  public resetRoamingToOriginalFilter: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonUserDetails: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonEmailNotAvailable: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonUsernameNotAvailable: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonSelectType: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonBackToOptinalDevices: BehaviorSubject<any> = new BehaviorSubject(null);
  public checkingGamingProfile: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonEmailAvailable: BehaviorSubject<any> = new BehaviorSubject(null);
  public arenaProAddonUsernameAvailable: BehaviorSubject<any> = new BehaviorSubject(null);
  public CHeckBOgoSKU: BehaviorSubject<any> = new BehaviorSubject(null);
  reloadDevicesList: BehaviorSubject<any> = new BehaviorSubject(null);
constructor() { }

}
